import { render, staticRenderFns } from "./ArchivedService.vue?vue&type=template&id=09a2dfe0&"
import script from "./ArchivedService.vue?vue&type=script&lang=js&"
export * from "./ArchivedService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports